var _path, _path2, _path3, _path4, _path5, _rect, _rect2, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForgotPassIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 223,
    height: 248,
    viewBox: "0 0 223 248",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.5 0H53.5L0 60.5C3.6 174.1 75.8333 232.5 111.5 247.5V0Z",
    fill: "url(#paint0_linear_334_1837)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112 30H70.3857L32 73.5111C34.583 155.211 86.4096 197.212 112 208V30Z",
    fill: "url(#paint1_linear_334_1837)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M111.5 0H169.5L223 60.5C219.4 174.1 147.167 232.5 111.5 247.5V0Z",
    fill: "url(#paint2_linear_334_1837)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M111 30H152.614L191 73.5111C188.417 155.211 136.59 197.212 111 208V30Z",
    fill: "url(#paint3_linear_334_1837)"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 86.3,
    y: -24.7,
    width: 160.9,
    height: 296.9
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(12.35px)",
      clipPath: "url(#bgblur_0_334_1837_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 24.7,
    d: "M111 0H169L222.5 60.5C218.9 174.1 146.667 232.5 111 247.5V0Z",
    fill: "url(#paint4_linear_334_1837)",
    fillOpacity: 0.4
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 151,
    y: 146,
    width: 71,
    height: 71,
    rx: 35.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 151,
    y: 146,
    width: 71,
    height: 71,
    rx: 35.5,
    stroke: "url(#paint5_linear_334_1837)",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M173 183.175L182.529 192.625L200 169",
    stroke: "#FF6C22",
    strokeWidth: 3.375,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_334_1837_clip_path",
    transform: "translate(-86.3 24.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111 0H169L222.5 60.5C218.9 174.1 146.667 232.5 111 247.5V0Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_334_1837",
    x1: 0.00000161728,
    y1: 16.3564,
    x2: 111.5,
    y2: 231.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.217548,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E6E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_334_1837",
    x1: 32,
    y1: 41.7634,
    x2: 112.299,
    y2: 196.081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.217548,
    stopColor: "#FF6C22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6649,
    stopColor: "#FFBB00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD9123"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_334_1837",
    x1: 223,
    y1: 16.3564,
    x2: 111.5,
    y2: 231.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.217548,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E6E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_334_1837",
    x1: 191,
    y1: 41.7634,
    x2: 110.701,
    y2: 196.081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.217548,
    stopColor: "#FF6C22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6649,
    stopColor: "#FFBB00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD9123"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_334_1837",
    x1: 222.5,
    y1: 16.3564,
    x2: 111,
    y2: 231.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.217548,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E6E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_334_1837",
    x1: 187,
    y1: 145,
    x2: 187,
    y2: 218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6C22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.239376,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43664,
    stopColor: "#FFBB00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595168,
    stopColor: "#FF6C22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.991745,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForgotPassIcon);
export default __webpack_public_path__ + "static/media/forgot-pass-icon.70c2b48378be0ca584b10e8cabd5a85c.svg";
export { ForwardRef as ReactComponent };